<template>
    <div>
        <b-modal
        id="modalInfo1"
        v-model="isOpen"
        modal-class="modalInfo1"
        :title="$t('label_evaluation_auditRecords_deleteFile')"
        >
            {{$t('label_evaluation_auditRecords_deleteConfirmation')}}
            <div slot="modal-footer" class="w-100" style="text-align: center">
            <b-row class="d-flex justify-content-center">
              <b-col cols="4">
                <b-btn @click="isOpen = false">
                  {{$t("label_evaluation_auditRecords_cancel")}}
                </b-btn>
              </b-col>
              <b-col cols="4">
                <b-btn variant="primary" @click="deleteFile()">
                  {{ $t("label_evaluation_auditRecords_deleteFile") }}
                </b-btn>
              </b-col>
            </b-row>
          </div>
        </b-modal>
    </div>
</template>

<script>
import { axiosCall } from "../../../../utils/axiosCall";
import { mapGetters } from "vuex";

export default {
  name: "DeleteRecordModal",
  props: {
    id: {
      type: String,
      default: '',
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
        evaluationId: this.$route.params.idEvaluation,
        isModalOpen: false,
    }
  },
  computed: {
    ...mapGetters(["getUserAccount"]),

    isOpen: {
      get() {
        return this.showModal;
      },
      set(newValue) {
        this.$emit("update:showModal", newValue);
      },
    },
  },
  methods:{
    deleteFile: async function () {
      await axiosCall({
        url:`Records/${this.id}`,
        method: "DELETE"
        }).then(() => {
            this.$emit('reload')
            this.isOpen = false;
      });
    },
  }
}
</script>

<style lang="scss" scoped>

.full-image {
    max-width: 1000px !important;
}

.thumbnail {
    max-width: 250px !important;
    &:hover {
        opacity: 0.5 !important;
        cursor: pointer;
    }
}

</style>
